export const ProductType = Object.freeze({
  HOSPITAL_ONLY: 'hospital',
  EXTRAS_ONLY: 'extras',
  PACKAGE: 'package',
});

export default ProductType;
